const mediaItems = [
  {
    title: '《狂飙》名场面：高启强与安欣天台对峙',
    duration: '03:25',
    views: '128万',
    image: 'https://readdy.ai/api/search-image?query=Intense%20dramatic%20scene%20between%20two%20men%20on%20rooftop%20at%20sunset%2C%20cinematic%20lighting%20with%20warm%20golden%20tones%2C%20TV%20drama%20aesthetic%2C%20emotional%20confrontation%20mood%2C%20film%20still%20style%20photography%2C%20high%20detail%20composition&width=600&height=340&seq=media-cinema-01&orientation=landscape',
  },
  {
    title: '《流浪地球2》太空电梯震撼长镜头',
    duration: '05:12',
    views: '96万',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20space%20elevator%20rising%20through%20atmosphere%20with%20dramatic%20golden%20sunlight%2C%20epic%20sci-fi%20cinematic%20scene%2C%20grand%20scale%20visual%20effects%20aesthetic%2C%20warm%20amber%20skies%2C%20blockbuster%20movie%20visual%2C%20high%20detail&width=600&height=340&seq=media-cinema-02&orientation=landscape',
  },
  {
    title: '《长相思》小夭相柳雪中诀别名场面',
    duration: '04:08',
    views: '85万',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20farewell%20scene%20in%20snow%20with%20warm%20golden%20hour%20backlighting%2C%20period%20costume%20drama%20aesthetic%2C%20emotional%20parting%20atmosphere%2C%20cinematic%20soft%20focus%2C%20warm%20tone%20photography%2C%20high%20detail%20composition&width=600&height=340&seq=media-cinema-03&orientation=landscape',
  },
  {
    title: '《封神第一部》冀州城之战全解析',
    duration: '06:45',
    views: '73万',
    image: 'https://readdy.ai/api/search-image?query=Epic%20ancient%20Chinese%20battle%20scene%20with%20warriors%20and%20dramatic%20smoke%2C%20cinematic%20golden%20hour%20lighting%2C%20historical%20fantasy%20war%20aesthetic%2C%20grand%20scale%20action%2C%20warm%20amber%20and%20earth%20tones%2C%20high%20detail&width=600&height=340&seq=media-cinema-04&orientation=landscape',
  },
  {
    title: '《奔跑吧》本季最搞笑特辑精彩集锦',
    duration: '08:30',
    views: '156万',
    image: 'https://readdy.ai/api/search-image?query=Funny%20variety%20show%20moment%20with%20colorful%20studio%20lighting%2C%20celebrities%20laughing%20energetic%20scene%2C%20bright%20warm%20atmosphere%2C%20entertainment%20program%20aesthetic%2C%20cheerful%20golden%20and%20coral%20tones%2C%20high%20detail%20photography&width=600&height=340&seq=media-cinema-05&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3 whitespace-nowrap">
            <i className="ri-play-circle-line"></i>精彩片段
          </span>
          <h2 className="font-heading text-[28px] md:text-4xl text-foreground-950 mb-3">影视精彩花絮</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            精选全网影视名场面与精彩片段，一睹为快
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {mediaItems.slice(0, 3).map((item) => (
            <div key={item.title} className="bg-background-50 rounded-xl overflow-hidden group cursor-pointer">
              <div className="aspect-video overflow-hidden bg-background-200 relative">
                <img
                  src={item.image}
                  alt={item.title}
                  title={`51影院片段 - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-background-950/60 group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-2xl text-background-50 ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 px-2 py-0.5 rounded bg-background-950/70 text-xs text-background-50 whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm md:text-base text-foreground-900 mb-2 leading-snug">{item.title}</h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span><i className="ri-eye-line mr-1"></i>{item.views}次播放</span>
                </div>
              </div>
            </div>
          ))}
          {mediaItems.slice(3, 5).map((item) => (
            <div key={item.title} className="bg-background-50 rounded-xl overflow-hidden group cursor-pointer sm:col-span-2 lg:col-span-3 flex flex-col sm:flex-row">
              <div className="sm:w-[45%] lg:w-[35%] aspect-video sm:aspect-auto overflow-hidden bg-background-200 relative shrink-0">
                <img
                  src={item.image}
                  alt={item.title}
                  title={`51影院片段 - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-background-950/60 group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-2xl text-background-50 ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 px-2 py-0.5 rounded bg-background-950/70 text-xs text-background-50 whitespace-nowrap">
                  {item.duration}
                </div>
              </div>
              <div className="p-5 flex flex-col justify-center">
                <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-2 leading-snug">{item.title}</h3>
                <span className="text-sm text-foreground-500"><i className="ri-eye-line mr-1"></i>{item.views}次播放</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}